export default __webpack_public_path__ + "static/media/33.afb2801d.png";